import { render, staticRenderFns } from "./modalpengesahan.vue?vue&type=template&id=5c57c8ac&scoped=true"
import script from "./modalpengesahan.vue?vue&type=script&lang=js"
export * from "./modalpengesahan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c57c8ac",
  null
  
)

export default component.exports